module.exports = __webpack_public_path__ + "img/29.1c01dbcb.gif";